// Images
import antes1 from "assets/images/cases/case-before1.png";
import despues1 from "assets/images/cases/case-after1.png";
import antes2 from "assets/images/cases/case-before2.png";
import despues2 from "assets/images/cases/case-after2.png";
import antes3 from "assets/images/cases/case-before3.png";
import despues3 from "assets/images/cases/case-after3.png";

import promoLimpieza from "assets/images/promotions/offer1.png";

import karenJaramillo from "assets/images/team/team-1.png";
// import arnoldPuentes from "assets/images/team/team-1.png";
// import estefani from "assets/images/team/team-1.png";
// import grisell from "assets/images/team/team-1.png";
// import jessica from "assets/images/team/team-1.png";
// import atziri from "assets/images/team/team-1.png";
// import paolaRodriguez from "assets/images/team/team-1.png";
// import samantha from "assets/images/team/team-1.png";
import defaultProfile from "assets/images/team/team-women-default.png";

const textData = {
  navbar: {
    actionButton: "Agendar cita 🦷",
  },
  captivePortalPage: {
    hero: {
      title: "¡Bienvenido a Jardent!",
      subtitle: "Gracias por conectarte a nuestra red. Ya tienes acceso a internet.",
    },
    main: {
      title: "Explora nuestros servicios",
      description:
        "Mientras navegas, te invitamos a conocer más sobre cómo podemos cuidar tu sonrisa.",
      button: "Ir a la página principal",
    },
    socials: {
      title: "O síguenos en nuestras redes",
      instagram: "Instagram",
      facebook: "Facebook",
    },
  },
  presentationPage: {
    hero: {
      title: "Tu Sonrisa, Nuestra Pasión",
      subtitle:
        "Ofrecemos atención dental de vanguardia en un ambiente cálido y profesional. Tu bienestar es nuestra prioridad.",
      button: "Agenda tu Valoración",
    },
    infoCards: [
      {
        id: "commitment",
        variant: "gradient",
        color: "info",
        title: "Cuidado Dental de Excelencia",
        description:
          "Ofrecemos tratamientos integrales y de alta calidad, combinando tecnología de punta con un enfoque humano y personalizado para cada paciente.",
      },
      {
        id: "smile",
        color: "info",
        title: "Tu Confianza, Nuestra Prioridad",
        description:
          "Creemos en el poder de una sonrisa segura. Nos dedicamos a la prevención y al cuidado detallado para que te sientas orgulloso de sonreír, libre de preocupaciones.",
      },
      {
        id: "health",
        color: "info",
        title: "Soluciones para Cada Necesidad",
        description:
          "Desde odontología general hasta tratamientos especializados como ortodoncia y endodoncia, diseñamos un plan a tu medida para restaurar y mantener tu salud bucal.",
      },
    ],
    specialties: {
      title: "¿Qué especialidad requieres?",
      subtitle:
        "Desde una revisión de rutina hasta tratamientos especializados, contamos con el experto ideal para cuidar de tu sonrisa. Explora nuestras especialidades.",
      button: "Ver todas las especialidades",
    },
    instagram: {
      title: "Únete a Nuestra Comunidad",
      subtitle:
        "Sigue nuestro día a día en Instagram y descubre consejos, transformaciones y momentos especiales en el consultorio.",
      viewOnInstagram: "Ver en Instagram",
    },
    reviews: {
      title: "Lo que dicen nuestros pacientes",
      subtitle: "Tu confianza es nuestro mayor logro.",
      google: {
        errorConfig:
          "La configuración de la API de Google (API Key y Place ID) no se ha encontrado. Revisa tu archivo .env.",
        errorNoReviews: "Este lugar aún no tiene reseñas en Google.",
        errorNetwork:
          "Lo sentimos, no pudimos cargar las reseñas en este momento. Por favor, intenta de nuevo más tarde.",
        cardTitle: "¿Te gustó nuestro servicio?",
        cardDescription:
          "Tu opinión nos ayuda a mejorar y a que más personas conozcan nuestro trabajo.",
        cardButton: "Dejar una reseña",
      },
    },
  },
  aboutUsPage: {
    us: {
      title: "Un Consultorio Creado para Ti",
      description:
        "En Jardent, hemos diseñado cada espacio pensando en tu comodidad y tranquilidad. Creemos que una visita al dentista debe ser una experiencia positiva y libre de estrés. Desde nuestra cálida recepción hasta nuestro moderno consultorio, nuestro objetivo es que te sientas como en casa mientras cuidamos de tu sonrisa.",
    },
    philosophy: {
      title: "Nuestra Filosofía",
      mission: {
        title: "Misión",
        description:
          "Transformar vidas a través de sonrisas saludables, ofreciendo un cuidado dental excepcional, personalizado y humano. Nos comprometemos a utilizar la mejor tecnología en un ambiente de máxima confianza y calidez para nuestros pacientes.",
      },
      vision: {
        title: "Visión",
        description:
          "Ser el consultorio dental de referencia en nuestra comunidad, reconocido por la excelencia de nuestros tratamientos, la innovación constante y por crear relaciones duraderas con nuestros pacientes, basadas en el cuidado y el respeto mutuo.",
      },
    },
    team: {
      title: "Nuestro Equipo",
      subtitle:
        "Para ofrecerte un cuidado integral, colaboramos con un equipo de especialistas apasionados, cada uno experto en su área y comprometido con la filosofía de Jardent.",
      members: [
        {
          image: karenJaramillo,
          name: "Karen Jaramillo",
          position: { color: "info", label: "Cirujana Dentista" },
          description:
            "Apasionada por la salud bucal y el bienestar de mis pacientes, liderando con dedicación y cuidado.",
        },
        // {
        //   image: arnoldPuentes,
        //   name: "Dr. Arnold Puentes",
        //   position: { color: "info", label: "Cirujano Maxilofacial" },
        //   description:
        //     "Experto en procedimientos quirúrgicos complejos para restaurar la función y estética facial.",
        // },
        // {
        //   image: estefani,
        //   name: "Dra. Estefani",
        //   position: { color: "info", label: "Odontopediatra" },
        //   description:
        //     "Dedicada a crear experiencias dentales positivas y saludables para los más pequeños.",
        // },
        // {
        //   image: grisell,
        //   name: "Dra. Grisell",
        //   position: { color: "info", label: "Ortodoncista" },
        //   description:
        //     "Especialista en alinear sonrisas y mejorar la mordida con las últimas tecnologías en ortodoncia.",
        // },
        // {
        //   image: jessica,
        //   name: "Dra. Jessica",
        //   position: { color: "info", label: "Periodoncista" },
        //   description:
        //     "Enfocada en la salud de las encías y el soporte de los dientes para una sonrisa duradera.",
        // },
        // {
        //   image: atziri,
        //   name: "Dra. Atziri",
        //   position: { color: "info", label: "Endodoncista" },
        //   description:
        //     "Maestra en salvar dientes y aliviar el dolor a través de tratamientos de conducto precisos.",
        // },
        {
          image: defaultProfile,
          name: "Paola Rodriguez",
          position: { color: "secondary", label: "Pasante de Odontología" },
          description:
            "Apasionada por la odontología, asegura que cada visita sea cómoda y que los pacientes reciban la mejor atención.",
        },
        {
          image: defaultProfile,
          name: "Samanta Nochebuena",
          position: { color: "secondary", label: "Pasante de Odontología" },
          description:
            "Futura odontóloga, apoya en los tratamientos garantizando un entorno estéril, seguro y amigable para el paciente.",
        },
      ],
    },
  },
  successCasesPage: {
    hero: {
      title: "Casos de Éxito",
      subtitle:
        "Sonrisas que hemos transformado. Pacientes felices con resultados que hablan por sí mismos.",
    },
    caseLabels: {
      before: "Antes",
      after: "Después",
    },
    cases: [
      {
        id: 1,
        title: "Restauración por Caries",
        description:
          "Se eliminó el tejido afectado por la caries y se reconstruyó el diente con resina de alta estética, devolviendo su forma y función natural.",
        beforeImage: antes1,
        afterImage: despues1,
      },
      {
        id: 2,
        title: "Reemplazo de Amalgama por Resina",
        description:
          "Se retiró una antigua amalgama de metal y se reemplazó por una restauración de resina biocompatible, logrando un resultado más estético y seguro.",
        beforeImage: antes2,
        afterImage: despues2,
      },
      {
        id: 3,
        title: "Restauración de Fractura Dental",
        description:
          "El paciente presentaba una fractura en el incisivo central. Se restauró la pieza utilizando resina compuesta para recuperar la anatomía y la sonrisa.",
        beforeImage: antes3,
        afterImage: despues3,
      },
    ],
  },
  specialtiesPage: {
    hero: {
      title: "Nuestras Especialidades",
      subtitle:
        "Encuentra el tratamiento perfecto para ti. Contamos con un equipo de especialistas dedicados a cada área de la odontología para ofrecerte un cuidado integral y de la más alta calidad.",
    },
  },
  contactUsPage: {
    hero: {
      title: "Ponte en Contacto",
    },
    contact: {
      title: "Estamos aquí para ayudarte",
      description:
        "La forma más rápida de agendar tu cita o resolver tus dudas es a través de WhatsApp. ¡Te esperamos!",
      button: "Contactar por WhatsApp",
      emergency: "En caso de emergencia, por favor llámanos directamente.",
    },
    location: {
      title: "Encuéntranos",
      address:
        "Primera cerrada de Domingo Ramirez, Paraje 9, San Juan, 09830 Ciudad de México, CDMX.",
      getDirections: "Cómo llegar",
      call: "Llamar",
    },
    schedule: {
      title: "Horario de Atención",
      days: "Lunes a Viernes: 9:00 AM - 7:00 PM",
      saturday: "Sábados: 9:00 AM - 2:00 PM",
    },
  },
  specialOffersPage: {
    hero: {
      title: "Promociones del Mes",
      subtitle: "Aprovecha nuestras ofertas especiales y dale a tu sonrisa el cuidado que merece.",
    },
    button: "Quiero esta Promoción",
    promotions: [
      {
        image: promoLimpieza,
        title: "Limpieza Dental Completa",
        description:
          "Incluye diagnóstico, pulido y aplicación de flúor. ¡Sonrisa radiante al instante!",
        price: "¡20% de descuento!",
      },
      // {
      //   image: promoBlanqueamiento,
      //   title: "Blanqueamiento LED",
      //   description: "Aclara hasta 8 tonos en una sola sesión. Resultados visibles y duraderos.",
      //   price: "$1,500 MXN",
      // },
      // {
      //   image: promoOrtodoncia,
      //   title: "Pack Ortodoncia Inicial",
      //   description:
      //     "Evaluación completa, radiografías y modelos de estudio para tu tratamiento de ortodoncia.",
      //   price: "$300 MXN",
      // },
      // {
      //   image: promoImplante,
      //   title: "Implante Dental de Titanio",
      //   description:
      //     "Recupera la función y estética de tu sonrisa con implantes de la más alta calidad.",
      //   price: "Desde $4,000 MXN",
      // },
    ],
    termsAndConditions: {
      title: "Términos y Condiciones",
      description:
        "Promociones válidas únicamente para pacientes de primera vez. No acumulable con otras ofertas. Todos los tratamientos están sujetos a una evaluación clínica previa por parte de nuestros especialistas.",
    },
  },
  privacyPolicyPage: {
    title: "Aviso de Privacidad",
    intro: {
      part1: "Consultorio Dental Jardent, mejor conocido como ",
      strong: "jardent",
      part2:
        ", con domicilio en Primera cerrada de Domingo Ramirez, Paraje 9, San Juan, 09830 Ciudad de México, CDMX y portal de internet https://jardent.com.mx, es el responsable del uso y protección de sus datos personales, y al respecto le informamos lo siguiente:",
    },
    purposes: {
      title: "¿Para qué fines utilizaremos sus datos personales?",
      description:
        "Los datos personales que recabamos de usted, los utilizaremos para las siguientes finalidades que son necesarias para el servicio que solicita:",
      list: [
        "Respuesta a mensajes del formulario de contacto.",
        "Prestación de cualquier servicio solicitado.",
      ],
    },
    integralNotice: {
      title: "¿Dónde puedo consultar el aviso de privacidad integral?",
      part1:
        "Para conocer mayor información sobre los términos y condiciones en que serán tratados sus datos personales, como los terceros con quienes compartimos su información personal y la forma en que podrá ejercer sus derechos ARCO, puede consultar el aviso de privacidad integral con una petición vía correo electrónico: ",
      strong: "contacto@jardent.com.mx",
    },
    lastUpdate: "Última actualización de este aviso de privacidad: 02/02/2023",
  },
  feedbackPage: {
    hero: {
      title: "Tu Opinión Nos Importa",
      subtitle: "Ayúdanos a mejorar con esta breve encuesta.",
    },
    sections: {
      generalExperience: {
        title: "Experiencia general:",
        questions: [
          {
            id: "experienceRating",
            text: "¿Cómo calificarías tu experiencia general en el consultorio dental?",
            options: [
              { value: "3", label: "Satisfecho 😄" },
              { value: "2", label: "Neutral 😐" },
              { value: "1", label: "Insatisfecho 😞" },
            ],
          },
          {
            id: "recommendationRating",
            text: "¿Recomendarías nuestro consultorio a familiares o amigos?",
            options: [
              { value: "si", label: "Sí ✅" },
              { value: "no", label: "No ❌" },
            ],
          },
        ],
      },
      staffAttention: {
        title: "Atención del personal:",
        questions: [
          {
            id: "staffRating",
            text: "¿Cómo calificarías la amabilidad y profesionalidad del personal?",
            options: [
              { value: "3", label: "Buena 😄" },
              { value: "2", label: "Neutral 😐" },
              { value: "1", label: "Mala 😞" },
            ],
          },
          {
            id: "staffResponseRating",
            text: "¿El personal respondió a tus preguntas y preocupaciones de manera adecuada?",
            options: [
              { value: "3", label: "Buena 😄" },
              { value: "2", label: "Neutral 😐" },
              { value: "1", label: "Mala 😞" },
            ],
          },
        ],
      },
      waitTime: {
        title: "Tiempo de espera y cita:",
        questions: [
          {
            id: "waitTimeRating",
            text: "¿El tiempo de espera para tu cita fue razonable?",
            options: [
              { value: "3", label: "Buena 😄" },
              { value: "2", label: "Neutral 😐" },
              { value: "1", label: "Mala 😞" },
            ],
          },
          {
            id: "facilityRating",
            text: "¿Cómo calificarías la facilidad para programar una cita?",
            options: [
              { value: "3", label: "Buena 😄" },
              { value: "2", label: "Neutral 😐" },
              { value: "1", label: "Mala 😞" },
            ],
          },
        ],
      },
      dentalTreatment: {
        title: "Tratamiento dental:",
        questions: [
          {
            id: "treatmentQualityRating",
            text: "¿Cómo calificarías la calidad del tratamiento dental recibido?",
            options: [
              { value: "3", label: "Buena 😄" },
              { value: "2", label: "Neutral 😐" },
              { value: "1", label: "Mala 😞" },
            ],
          },
          {
            id: "procedureExplanationRating",
            text: "¿El dentista explicó claramente el procedimiento y cualquier opción de tratamiento?",
            options: [
              { value: "3", label: "Buena 😄" },
              { value: "2", label: "Neutral 😐" },
              { value: "1", label: "Mala 😞" },
            ],
          },
        ],
      },
      safety: {
        title: "Seguridad y medidas preventivas COVID-19:",
        questions: [
          {
            id: "safetyImprovementsRating",
            text: "¿Te sentiste seguro/a con las medidas de seguridad e higiene implementadas en el consultorio?",
            options: [
              { value: "3", label: "Buena 😄" },
              { value: "2", label: "Neutral 😐" },
              { value: "1", label: "Mala 😞" },
            ],
          },
          {
            id: "safetyImprovementSuggestion",
            text: "¿Hay alguna sugerencia que tengas para mejorar la seguridad durante tu próxima visita?",
            options: [
              { value: "si", label: "Sí ✅" },
              { value: "no", label: "No ❌" },
            ],
          },
        ],
        commentsLabel: "Comentarios Adicionales",
      },
    },
    submitButton: "Enviar Encuesta",
    successModal: {
      title: "Hemos terminado!!",
      description: "Gracias por tus comentarios. :)",
      actionLabel: "Finalizar",
    },
  },
  components: {
    postErrorFallback: {
      message: "No se pudo cargar esta publicación.",
    },
  },
};

export default textData;
